
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pageName]",
      function () {
        return require("private-next-pages/[pageName].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pageName]"])
      });
    }
  